module.exports = __webpack_public_path__ + "img/tu07.9824156f.jpg";